// Catégorie de poids Karaté
function getWeightCategory(gender, ageCategory, weight) {
  const weightCategories = {
    // Féminines
    "Mini poussinF": [25, 35],
    PoussinF: [25, 35],
    PupilleF: [25, 30, 35, 40, 45],
    BenjaminF: [30, 35, 40, 45, 50],
    MinimeF: [35, 40, 45, 50, 55],
    CadetF: [47, 54, 61],
    JuniorF: [48, 53, 59, 66],
    SéniorF: [50, 55, 61, 68],
    EspoirF: [50, 55, 61, 68],
    "Vétéran 1F": [55, 61, 68],
    "Vétéran 2F": [55, 61, 68],
    "Vétéran 3F": [55, 61, 68],
    "Vétéran 4F": [55, 61, 68],
    "Vétéran 5F": [55, 61, 68],

    // Masculins
    "Mini poussin": [25, 35],
    Poussin: [25, 35],
    Pupille: [25, 30, 35, 40, 45, 50],
    Benjamin: [30, 35, 40, 45, 50, 55],
    Minime: [35, 40, 45, 50, 55, 60, 65],
    Cadet: [52, 57, 63, 70],
    Junior: [55, 61, 68, 76],
    Sénior: [60, 67, 75, 84],
    Espoir: [60, 67, 75, 84],
    "Vétéran 1": [67, 75, 84],
    "Vétéran 2": [67, 75, 84],
    "Vétéran 3": [67, 75, 84],
    "Vétéran 4": [67, 75, 84],
    "Vétéran 5": [67, 75, 84],
  };

  const normalizeAgeCategory = (category = "") => {
    const value = String(category)
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/-/g, " ")
      .replace(/\s+/g, " ");

    if (value === "eveil" || value === "eveils") return "Eveil";

    if (
      value === "mini poussin" ||
      value === "mini poussins" ||
      value === "mini poussine" ||
      value === "mini poussines"
    ) {
      return "Mini poussin";
    }

    if (
      value === "poussin" ||
      value === "poussins" ||
      value === "poussine" ||
      value === "poussines"
    ) {
      return "Poussin";
    }

    if (
      value === "pupille" ||
      value === "pupilles"
    ) {
      return "Pupille";
    }

    if (
      value === "benjamin" ||
      value === "benjamins" ||
      value === "benjamine" ||
      value === "benjamines"
    ) {
      return "Benjamin";
    }

    if (value === "minime" || value === "minimes") return "Minime";

    if (
      value === "cadet" ||
      value === "cadets" ||
      value === "cadette" ||
      value === "cadettes"
    ) {
      return "Cadet";
    }

    if (value === "junior" || value === "juniors") return "Junior";

    if (
      value === "senior" ||
      value === "seniors" ||
      value === "senior" ||
      value === "séniors"
    ) {
      return "Sénior";
    }

    if (value === "espoir" || value === "espoirs") return "Espoir";

    if (value === "veteran 1" || value === "veterans 1") return "Vétéran 1";
    if (value === "veteran 2" || value === "veterans 2") return "Vétéran 2";
    if (value === "veteran 3" || value === "veterans 3") return "Vétéran 3";
    if (value === "veteran 4" || value === "veterans 4") return "Vétéran 4";
    if (value === "veteran 5" || value === "veterans 5") return "Vétéran 5";

    return category;
  };

  const normalizeGender = (genderValue = "") => {
    const value = String(genderValue)
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");

    if (
      value === "feminin" ||
      value === "femme" ||
      value === "female" ||
      value === "f"
    ) {
      return "Féminin";
    }

    return "Masculin";
  };

  const normalizedAgeCategory = normalizeAgeCategory(ageCategory);
  const normalizedGender = normalizeGender(gender);

  const numericWeight = parseFloat(weight);

  if (
    weight === null ||
    weight === undefined ||
    weight === "" ||
    numericWeight === 0
  ) {
    return "Non pesé(e)";
  }

  if (Number.isNaN(numericWeight)) {
    return "Poids invalide";
  }

  if (normalizedAgeCategory === "Inconnu") {
    return "Catégorie d'âge inconnue";
  }

  // Pas de catégorie de poids officielle dans ton tableau pour Eveil
  if (normalizedAgeCategory === "Eveil") {
    return "GM";
  }

  const categoryKey =
    normalizedGender === "Féminin"
      ? `${normalizedAgeCategory}F`
      : normalizedAgeCategory;

  if (!Object.prototype.hasOwnProperty.call(weightCategories, categoryKey)) {
    console.error(`Catégorie inconnue: ${categoryKey}`);
    return "Catégorie inconnue";
  }

  const categories = weightCategories[categoryKey];
  const lastCategory = categories[categories.length - 1];

  if (numericWeight >= lastCategory) {
    return `+${lastCategory} kg`;
  }

  const selectedCategory = categories.find((cat) => numericWeight < cat);

  return selectedCategory ? `-${selectedCategory} kg` : "Aucune catégorie";
}

export default getWeightCategory;